






















import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useStore } from '../../store';
import { Basket } from '../../store/order/types';
import OrderNavBar from '../../component/navigation/OrderNavBar.vue';

export default defineComponent({
  name: 'BaseOrderCheckoutLayout',
  components: { OrderNavBar },
  setup: () => {
    const store = useStore();

    const state = reactive({
      productName: computed((): string => (store.getters['order/basket'] as Basket)?.name),
    });

    return {
      state,
    };
  },
});
